// Components
import HLSVideoPlayer from '~fpu/shared/components/HLSVideoPlayer';
import MemberDashboardLayout from '../MemberDashboardLayout';
import { PlayIconBlue } from '~fpu/shared/components/icons/play-icon/PlayIconBlue';

// Libs
import { Link, useSearchParams } from 'react-router';

// RDS
import Button from '@ramsey-design-system/button';
import Heading from '@ramsey-design-system/heading';
import Tag from '@ramsey-design-system/tag';
import Text from '@ramsey-design-system/text';
import { ChevronLeftIcon } from '@ramsey-design-system/icons';

// Utils
import { analyticsLogger } from '~fpu/shared/utils/analytics';
import { BETTER_THAN_I_DESERVE_VIDEO } from '../utils/constants';
import { PATHS } from '~fpu/config/constants';

function DaveTestimony() {
  const [searchParams] = useSearchParams();
  const autoplay = searchParams.get('autostart') === 'true';
  const video = {
    src: BETTER_THAN_I_DESERVE_VIDEO.src,
    thumbnail:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/daves-story/better-than-i-deserve.png'
  };

  const handlePlay = () => {
    analyticsLogger.trackElementClicked({
      element: 'Dave Testimony Video',
      label: 'Play Dave Testimony'
    });
  };

  return (
    <MemberDashboardLayout page="video">
      <div className="max-w-[1000px] md:pt-5">
        <Button
          element={Link}
          to={PATHS.MEMBER_DASHBOARD.LESSONS}
          icon={ChevronLeftIcon}
          appearance="subtle"
          className="mb-2"
        >
          All Lessons
        </Button>

        <HLSVideoPlayer
          src={video.src}
          thumbnail={video.thumbnail}
          onPlay={handlePlay}
          autoplay={autoplay}
          data-testid="video-player-dave-testimony"
          playIcon={
            <PlayIconBlue className="absolute top-1/2 left-1/2 h-8 w-8 -translate-x-1/2 -translate-y-1/2 rounded-full border-white transition duration-300 ease-in-out group-hover:scale-125 group-hover:border-[6px] group-hover:border-white sm:h-[84px] sm:w-[84px] md:h-[104px] md:w-[104px] lg:h-[84px] lg:w-[84px] xl:h-[104px] xl:w-[104px]" />
          }
        />

        <div
          className="py-3 pt-3 md:py-5"
          data-testid="lesson-video-thumbnail-details"
        >
          <div className="mb-2 flex flex-col items-start justify-between sm:flex-row sm:items-center">
            <Heading
              level="2"
              data-testid="lesson-video-thumbnail-details-heading"
              className="text-8 leading-md text-gray-90 md:text-10 mr-1 mb-2 sm:mb-0"
            >
              Dave Ramsey&apos;s Story
            </Heading>
            <Tag
              color="primary"
              size="lg"
              data-testid="lesson-video-thumbnail-details-pill"
            >
              Bonus Video
            </Tag>
          </div>
          <Text
            size="bodyMedium"
            className="text-5 leading-lg text-gray-70"
            data-testid="lesson-video-thumbnail-details-description"
          >
            Dave shares how, after hitting rock bottom and filing bankruptcy, he
            found the truth about managing money and the love of Jesus Christ.
          </Text>
        </div>
      </div>
    </MemberDashboardLayout>
  );
}

export default DaveTestimony;
